var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'vl-accordion-item',
    {
      'is-open': _vm.active,
    },
  ]},[_c('div',{staticClass:"vl-accordion-item__title",attrs:{"role":"button"},on:{"click":_vm.toggle}},[_vm._t("title")],2),_vm._v(" "),_c('transition',{attrs:{"name":"animation-height"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave,"leave":_vm.leave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],ref:"description",staticClass:"vl-accordion-item__description"},[_c('div',{staticClass:"vl-accordion-item__description-inner"},[_vm._t("description")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }